import Icon from "@pdfking/workflow/components/Icon"
import { defineComponent, withModifiers } from "vue"
import can_hover from "../../../features/can_hover"

export default defineComponent({
  data() {
    return {
      hover: {} as Record<string, ReturnType<typeof setTimeout>>,
    }
  },
  methods: {
    hover_cancel(id: string) {
      if (can_hover() && this.hover[id]) {
        clearTimeout(this.hover[id])
        delete this.hover[id]
      }
    },

    hover_start(id: string) {
      if (can_hover()) {
        this.hover_cancel(id)

        this.hover[id] = setTimeout(() => {
          this.hover_cancel(id)
          this.action(id)
        }, 200)
      }
    },
  },
  props: {
    action: {
      required: true,
      type: Function,
    },
    badge: {
      default: null,
      required: false,
      type: String,
    },
    filters: {
      default: () => [],
      required: false,
      type: Array,
    },
    selected: {
      default: null,
      type: String,
    },
  },
  render() {
    return (
      <div class="list-group list-group-flush">
        {(this.filters as any[]).map((filter: any) => (
          <a
            key={filter.id}
            class={[
              "list-group-item list-group-item-action d-flex align-items-center",
              { active: filter.id === this.selected },
            ]}
            href="#"
            onClick={withModifiers(
              () => this.action(filter.id),
              ["stop", "prevent"]
            )}
            onMouseout={() => this.hover_cancel(filter.id)}
            onMouseover={() => this.hover_start(filter.id)}
          >
            {filter.icon && <Icon class="me-1" name={filter.icon} />}
            <span innerHTML={filter.title} />
            {filter.badge ? (
              <span
                class="position-absolute end-0 me-2 bg-light text-primary badge rounded-pill"
                innerHTML={filter.badge}
              />
            ) : (
              <Icon class="position-absolute end-0 me-2" name="CHEVRON_RIGHT" />
            )}
          </a>
        ))}
      </div>
    )
  },
})
